import AddCircleOutlineRounded from "@mui/icons-material/AddCircleOutlineRounded";
import Settings from "@mui/icons-material/Settings";
import { Button, ButtonProps, SxProps } from "@mui/material";

interface WorkspaceActionButtonProps extends ButtonProps {
  text: string;
  actionType?: "add" | "settings" | "warning";
  sx?: SxProps;
}

const ICON_BY_ACTION_TYPE = {
  add: AddCircleOutlineRounded,
  settings: Settings,
  warning: null,
};

const WorkspaceActionButton = ({
  text,
  actionType = "add",
  ...buttonProps
}: WorkspaceActionButtonProps) => {
  const Icon = ICON_BY_ACTION_TYPE[actionType];
  return (
    <Button {...buttonProps}>
      {Icon && <Icon sx={{ mr: 1, width: "18px" }} />}
      {text}
    </Button>
  );
};
export default WorkspaceActionButton;
